let balls = [
  {
    name: "Poké Ball",
    type: "poke",
    rate: 1,
    flavour:
      "A device for catching wild Pokémon. It's thrown like a ball at a Pokémon, comfortably encapsulating its target."
  },
  {
    name: "Premier Ball",
    type: "premier",
    rate: 1,
    flavour:
      "A somewhat rare Poké Ball that was made as a commemorative item used to celebrate an event of some sort."
  },
  {
    name: "Luxury Ball",
    type: "luxury",
    rate: 1,
    flavour:
      "A particularly comfortable Poké Ball that makes a wild Pokémon quickly grow friendlier after being caught."
  },
  {
    name: "Heal Ball",
    type: "heal",
    rate: 1,
    flavour:
      "A remedial Poké Ball that restores the HP of a Pokémon caught with it and eliminates any status conditions."
  },
  {
    name: "Great Ball",
    type: "great",
    rate: 1.5,
    flavour:
      "A good, high-performance Poké Ball that provides a higher success rate for catching Pokémon than a standard Poké Ball."
  },
  {
    name: "Ultra Ball",
    type: "ultra",
    rate: 2,
    flavour:
      "An ultra-high-performance Poké Ball that provides a higher success rate for catching Pokémon than a Great Ball."
  },
  {
    name: "Nest Ball",
    type: "nest",
    rate: 1,
    flavour:
      "A somewhat different Poké Ball that becomes more effective the lower the level of the wild Pokémon."
  },
  {
    name: "Net Ball",
    type: "net",
    rate: 1,
    flavour:
      "A somewhat different Poké Ball that is more effective when attempting to catch Water- or Bug-type Pokémon."
  },
  {
    name: "Dusk Ball",
    type: "dusk",
    rate: 3,
    flavour:
      "A somewhat different Poké Ball that makes it easier to catch wild Pokémon at night or in dark places such as caves."
  },
  {
    name: "Dive Ball",
    type: "dive",
    rate: 3.5,
    flavour:
      "A somewhat different Poké Ball that works especially well when catching Pokémon that live underwater."
  },
  {
    name: "Quick Ball",
    type: "quick",
    rate: 5,
    flavour:
      "A somewhat different Poké Ball that has a more successful catch rate if used at the start of a wild encounter."
  },
  {
    name: "Repeat Ball",
    type: "repeat",
    rate: 3.5,
    flavour:
      "A somewhat different Poké Ball that works especially well on a Pokémon species that has been caught before."
  },
  {
    name: "Timer Ball",
    type: "timer",
    rate: 4,
    flavour:
      "A somewhat different Poké Ball that becomes progressively more effective at catching Pokémon the more turns that are taken in battle."
  },
  {
    name: "Safari Ball",
    type: "safari",
    rate: 1.5,
    flavour:
      "A special Poké Ball that was used in the Safari Zone in the Kanto region and in the Great Marsh in the Sinnoh region."
  },
  {
    name: "Master Ball",
    type: "master",
    rate: 99,
    flavour:
      "The best Poké Ball with the ultimate level of performance. With it, you will catch any wild Pokémon without fail."
  }
];

export default balls;
